<template>
  <div
    :class="[
      'd-flex flex-column rounded-lg',
      { 'border-gray': !noBorder, 'px-6 py-4': !small && !noPadding, 'px-3 py-2': small && !noPadding },
    ]"
    :style="`${!!borderColor && !noBorder ? `border-color: ${borderColor}` : ''}`"
  >
    <form-node v-if="!!content" v-bind="content" v-on="$listeners" />
    <slot v-else />
  </div>
</template>

<script>
import { PropsDefinition } from '@/_typedefs'
import { FormNodeProps } from '../FormNode.vue'

/**
 * @typedef {Object} BoxNodeProps
 * @property {boolean} [small]
 * @property {string} [borderColor]
 * @property {boolean} [noBorder]
 * @property {boolean} [noPadding]
 * @property {FormNodeProps} content
 */

export default {
  /** @type {PropsDefinition<BoxNodeProps>} */
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    borderColor: {
      type: String,
      default: null,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style scoped>
.border-gray {
  border: 1px solid #e6e6e6;
}
</style>
